import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum DocumentsReportResolverErrorStatesEnum {
    GetDocumentFailed = ErrorStateScheduleEnum.DocumentsReportResolverErrorStatesStartIndex
}
